import { render, staticRenderFns } from "./zfbAuth.vue?vue&type=template&id=274d86d5&"
import script from "./zfbAuth.vue?vue&type=script&lang=js&"
export * from "./zfbAuth.vue?vue&type=script&lang=js&"
import style0 from "./zfbAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports